import { render, staticRenderFns } from "./GridWeekSelect.vue?vue&type=template&id=b2a04da4&scoped=true"
import script from "./GridWeekSelect.vue?vue&type=script&lang=js"
export * from "./GridWeekSelect.vue?vue&type=script&lang=js"
import style0 from "./GridWeekSelect.vue?vue&type=style&index=0&id=b2a04da4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a04da4",
  null
  
)

export default component.exports